import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
// import { scrollToTop } from '../core/index';
import { getAjaxhelper } from 'src/utils';
export interface GrandMirageProps extends BaseComponentProps {
    lang: string;
    history?: History | any;
}

export interface GrandMirageState extends BaseComponentState {
    formSubmit: {
        name: string,
        email: string,
        phone: string,
        country: string,
        subject: string,
        msg: string,
    };
}
/*
const GMimages = {
    "satu" : [
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Premiere-Garden-View-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-23-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-25-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-18-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-15-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-12-400x314.jpg',
        'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Thalasso-Bali-3-400x314.jpg',

    ]
};
*/

interface GrandMirageDataSt {
    imageUrl: string;
    roomName: string;
    price: number;
    curencyCode: 'USD' | 'AUD' | 'IDR';
    linkUrl: string;
}

const GrandMirageData: GrandMirageDataSt[] = [
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Premiere-Garden-View-400x314.jpg',
        roomName: 'Premiere Garden – All Inclusive, Grand Mirage',
        price: 278,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/premiere-garden-all-inclusive-grand-mirage/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Premiere-Ocean-View-400x314.jpg',
        roomName: 'Premiere Ocean – All Inclusive, Grand Mirage',
        price: 301,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/premiere-ocean-all-inclusive-grand-mirage/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Family-Studio-Queen-400x314.jpg',
        roomName: 'Family Studio Queen – All Inclusive, Grand Mirage',
        price: 342,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/family-studio-queen-all-inclusive-grand-mirage/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Kids-Suite-2-400x314.jpg',
        roomName: 'Kids Suite – All Inclusive, Grand Mirage',
        price: 412,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/kids-suite-all-inclusive-grand-mirage/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/Ocean-View-Suite-1-400x314.jpg',
        roomName: 'Ocean View Suites – All Inclusive, Grand Mirage',
        price: 430,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/ocean-view-suites-all-inclusive-grand-mirage/'
    },
    {
        imageUrl: 'https://www.balivillasandmore.com/wp-content/uploads/2018/12/2-Bedroom-Suite-1-400x314.jpg',
        roomName: '2 Bedroom Suite – All Inclusive, Grand Mirage',
        price: 502,
        curencyCode: 'USD',
        linkUrl: 'https://www.balivillasandmore.com/properties/2-bedroom-suite-all-inclusive-grand-mirage/'
    }
];
export class GrandMirage extends BaseComponent<GrandMirageProps, GrandMirageState> {
    constructor(props: GrandMirageProps) {
        super(props);
        this.state = {
            formSubmit: {
                name: '',
                email: '',
                phone: '',
                msg: '',
                country: '',
                subject: ''
            }
        };
    }

    componentDidUpdate() {
        // scrollToTop();
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let roomandrate = [];
        for (let rate of GrandMirageData) {
            roomandrate.push(
                <div className="col-md-4">
                    <div
                        style={{ marginBottom: 30, border: '1px #ddd solid', cursor: "pointer" }}
                        onClick={
                            () => {
                                window.open(`${rate.linkUrl}`, '_blank');
                                // window.location.href = ;
                            }
                        }
                    >
                        <div>
                            <img width="100%" src={`${rate.imageUrl}`} />
                        </div>
                        <div style={{ padding: 15, marginBottom: 35 }}>
                            <h4 style={{ fontWeight: 800, color: '#2eb7fd' }}>{rate.roomName}</h4>
                            <h3 style={{ float: 'right', fontWeight: 800, color: 'rgb(95, 73, 255)' }}>{`${rate.curencyCode} ${rate.price}`}</h3>
                            <p>
                                <a href={`${rate.linkUrl}`} className="btn btn-primary form-control" style={{float: "right"}} target="_blank" >Book Online Now</a>
                            </p>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div style={{ paddingBottom: 20, fontSize: 14, paddingTop: 130 }}>
                <div>
                <video
                    poster="https://storage.googleapis.com/balivillasandmore/video/Grand-Mirage-Fully-Inclusive.jpg" 
                    loop={true}
                    controls={true}
                    width="100%"
                    height="auto"
                >
                    <source src="https://storage.googleapis.com/balivillasandmore/video/Grand-Mirage-Fully-Inclusive.mp4" type="video/mp4" />
                    Your browser doesn’t support HTML5 video. Here is<br /> a <a href="https://storage.googleapis.com/balivillasandmore/video/Grand-Mirage-Fully-Inclusive.mp4">link to the video</a> instead.
                </video>
                </div>
                
                <div style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/grand-mirage-spacer-1.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <h2 style={{ textAlign: 'center', fontWeight: 800 }}>Grand Mirage Hotel – An All-Inclusive Bali Luxury Resort</h2>
                    <h2 style={{ textAlign: "center", fontWeight: 800 }}><i className="fa fa-file-pdf-o" /><a href="https://www.balivillasandmore.com/wp-content/uploads/2018/10/Gold-All-Inclusive-Information.pdf" target="_blank" rel="noopener noreferrer">– Download Fact Sheet Here</a> [PDF 5.2MB]</h2>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30 }}>
                        <h3>About Grand Mirage Hotel</h3>
                        <p>You have been working all-the-year-round, and it is now time to enjoy the fruits of your hard work! Well, perhaps you have heard that Bali, the islands of God, has it all it takes to redefine your vacation. That being the case, you and your loved ones have only dream –exploring Bali from the comfort of a luxury beachfront hotel. Yes, there are many accommodation spots in this region, but none matches the elegance of the Grand Mirage Hotel!</p>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://www.balivillasandmore.com/wp-content/uploads/2018/12/grand-mirage-nusa-dua-beach-front.jpg" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30 }}>
                        <h3>The All Inclusive Offer</h3>
                        <p>We know that you are dreaming of exploring Bali while enjoying the very best hospitality experience, and we strive to live up to your expectation. This explains why we have plenty of offers to mesmerize our guests and one of them is called the Gold All-Inclusive Package, which allows our valued visitors to explore the sumptuousness of this five-star beachfront resort. Our gold package includes non-motorized water sports, airport transfers, unlimited exquisite meals & beverages in every outlet, and majestic rooms –just to mention a few! With all friendly and warmly services & activities, our unparalleled resort is an excellent spot for couples and families alike.</p>
                        <a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://www.balivillasandmore.com/wp-content/uploads/2018/12/grand-mirage-all-inclusive.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30 }}>
                        <h3>Drinks</h3>
                        <p>Did we say that the package includes unlimited meals and beverages? Yes, our stunning bars and restaurants is the home of exceptional cuisines and dinners. We endeavor to provide a daily breakfast buffet, sumptuous lunch, afternoon coffee and tea buffet, and room service if you feel hungry in between main meals. While it is not easy to find an Indian menu in most Bali resorts, our luxury beachfront facility now includes it in the many choices of an all-inclusive package. This new menu gives guests a wonderful chance to indulge in melodramatic gastronomic experiences of a hearty fine meal made up of authentic Indiana spices!</p>
                        <a href="#frmSumbit" className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://www.balivillasandmore.com/wp-content/uploads/2018/12/grand-mirage-drink.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 " style={{ marginTop: 30 }}>
                        <h3>Food</h3>
                        <p>The special Gold package includes unlimited beverages available across all our minibars. Here, you will find a wide selection of soft drinks, cocktails, alcoholic brands, beer & wine, and many other drinks. Guests can order any drink at any of the time. For cocktails parties, we shall extend the package to include selected international premium brands.</p>
                        <a href="#frmSumbit" style={{ float: "right" }} className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6 ">
                        <img src="https://www.balivillasandmore.com/wp-content/uploads/2018/12/grand-mirage-food.gif" width='100%' />
                    </div>
                </div>
                <div className="container">
                    <div className="col-md-6 col-md-push-6" style={{ marginTop: 30 }}>
                        <h3>Activities</h3>
                        <p>Guests who love motorsports and may other water recreational activities will find our All-inclusive Gold package amazing. Through the guidance of our water sports attendant, guests will enjoy both big and small ocean kayak accessible through non-motorized sports counter. Other services and activities available in this package include Banana boat, Nusa-Dua speedboat cruising, jet skiing, sea walking, Catamaran sailing, and windsurfing. While kids are not allowed into the gym room, adult guests can tone up their bodies at the massively equipped gym room.</p>
                        <a href="#frmSumbit" className="btn btn-primary">Enquire Now</a>
                    </div>
                    <div className="col-md-6  col-md-pull-6">
                        <img src="https://www.balivillasandmore.com/wp-content/uploads/2018/12/grand-mirage-activities.gif" width='100%' />
                    </div>
                </div>
                <div id='frmSumbit' style={{ padding: '20px', background: `url("https://storage.googleapis.com/bali-hotel-images/grand-mirage-swim-up-bars.jpg")`, backgroundSize: 'cover', backgroundPosition: 'center' }} >
                    <div className='container'>
                        <div className="col-md-6 " style={{ marginTop: 30 }}>
                            <div>
                                <form id="contactForm" onSubmit={this.formSubmit} style={{ maxWidth: 600, margin: 'auto', padding: 20, background: '#ffffffa8' }}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h3 style={{ color: 'rgb(43, 40, 74)', fontWeight: 800 }}>Send Us An Enquiry</h3>
                                            <p style={{ color: 'rgb(43, 40, 74)' }}>Fields marked with an <span className="symbol required" /> are required</p>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Your name <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.name}
                                                    onChange={  
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.name = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                        
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Email address <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="email"
                                                    className="form-control"
                                                    value={this.state.formSubmit.email}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.email = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Phone / Whatsapp </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    data-msg-required="Please enter phone number."
                                                    className="form-control"
                                                    value={this.state.formSubmit.phone}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.phone = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Country <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.country}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.country = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Subject <span className="symbol required" /> </label>
                                                <input
                                                    required={true}
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.formSubmit.subject}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.subject = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div className="row">
                                        <div className="form-group">
                                            <div className="col-md-12">
                                                <label style={{ color: 'rgb(43, 40, 74)', textAlign: 'left' }}> Message <span className="symbol required" /> </label>
                                                <textarea
                                                    required={true}
                                                    data-msg-required="Please enter your message."
                                                    className="form-control"
                                                    rows={5}
                                                    value={this.state.formSubmit.msg}
                                                    onChange={
                                                        (evt: any) => {
                                                            let formSubmit = this.state.formSubmit;
                                                            formSubmit.msg = evt.target.value;
                                                            this.setState({ formSubmit });
                                                        }
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button data-caption-delay="900" type="submit" data-caption-class="fadeIn" className="btn btn-primary margin-top-15 opacity-0 btn-wide btn-scroll btn-scroll-top fa-arrow-right animated fadeIn" >
                                                <span>Enquire Now</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ marginTop: 30 }}>
                    <h3 style={{ textAlign: 'center' }}>Rooms & Suites</h3>
                    {roomandrate}
                </div>
            </div>

        );

    }

    formSubmit = (event: any) => {
        event.preventDefault();
        let nameSender = this.state.formSubmit.name;
        let contentClient = "";
        contentClient = "<h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>";
        contentClient += `<p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com.au/terms-of-use" target="_blank">https://www.balihotelsandmore.com.au/terms-of-use</a></p>`;
        contentClient += "<p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>";
        contentClient += "<p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>";
        contentClient += `<p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/">https://www.solemen.org</a> &nbsp;</p>`;
        contentClient += `<p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/">https://www.stellaschild.org/</a></p>`;
        contentClient += "<p>Your booking really does make a difference here in Bali!</p>";
        contentClient += "<p>We look forward to speaking to you within the next 24 - 48 hours.</p>";
        let contentAdmin = "";
        contentAdmin += `Name : ${this.state.formSubmit.name} <br>`;
        contentAdmin += `email : ${this.state.formSubmit.email} <br>`;
        contentAdmin += `country : ${this.state.formSubmit.country} <br>`;
        contentAdmin += `phoneNumber : ${this.state.formSubmit.phone} <br>`;
        contentAdmin += `Subject : ${this.state.formSubmit.subject} <br><br><br>`;
        contentAdmin += `message : ${this.state.formSubmit.msg} <br><br><br>`;
        contentAdmin += `URL : https://balihotelsandmore.com.au/grand-mirage-hotel-an-all-inclusive-bali-luxury-resort<br><br>`;
        let subject = "[Bali Hotels and More] Grand Mirage Hotel All Inclusive " + `${this.state.formSubmit.subject}`;
        let emailSender = this.state.formSubmit.email;

        let dataSendEmail = {
            nameSender: nameSender,
            contentClient: (contentClient),
            contentAdmin: (contentAdmin),
            emailSender: emailSender,
            subject: subject
        };
        getAjaxhelper().post("/dynamics/email-sender-bham/enquery", dataSendEmail).then(
            x => {
                this.props.history.push('/settlement-thankyou');
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/GrandMirage.tsx